import { Link } from "react-router-dom";
import { scrollToId } from "../../lib/api";
import ElevareLockup from "./ElevareLockup";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#ded9cb] border-t border-black/10 py-16">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <ElevareLockup markSize={72} align="left" />
            <p className="mt-5 text-sm leading-relaxed text-black/60">
              Elevare helps businesses understand performance, uncover opportunities, and turn
              insight into measurable improvement.
            </p>
            <div className="mt-6 space-y-2">
              <a href="mailto:kalib@elevaresolutions.me" className="block text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300">Kalib Whaley · (260) 200-0907</a>
              <a href="mailto:john@elevaresolutions.me" className="block text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300">John Caron · (931) 802-3183</a>
            </div>
          </div>
          <div className="flex flex-wrap gap-16">
            <div>
              <span className="text-xs uppercase tracking-[0.2em] text-black/45">Explore</span>
              <div className="mt-5 flex flex-col gap-3">
                {[["Services", "services"], ["How it works", "process"], ["AI Forecast", "predictor"], ["Pricing", "pricing"]].map(([l, id]) => (
                  <button key={id} onClick={() => scrollToId(id)} className="text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300 text-left">{l}</button>
                ))}
              </div>
            </div>
            <div>
              <span className="text-xs uppercase tracking-[0.2em] text-black/45">Tools</span>
              <div className="mt-5 flex flex-col gap-3">
                {[["Start Your Business Assessment", "contact"]].map(([l, id]) => (
                  <button key={id} onClick={() => scrollToId(id)} className="text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300 text-left">{l}</button>
                ))}
                <Link to="/plans" data-testid="footer-plans" className="text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300 text-left">Plans &amp; Pricing</Link>
                <Link to="/admin" data-testid="footer-admin" className="text-sm text-[#a3823f] hover:text-[#1e3d3a] transition-colors duration-300 text-left">Owner Dashboard</Link>
              </div>
            </div>
            <div>
              <span className="text-xs uppercase tracking-[0.2em] text-black/45">Legal</span>
              <div className="mt-5 flex flex-col gap-3">
                <Link to="/terms" data-testid="footer-terms" className="text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300 text-left">Terms of Service</Link>
                <Link to="/privacy-policy" data-testid="footer-privacy" className="text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300 text-left">Privacy Policy</Link>
                <Link to="/sms-terms" data-testid="footer-sms-terms" className="text-sm text-black/65 hover:text-[#1e3d3a] transition-colors duration-300 text-left">Campaign Terms of Service</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-black/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-black/40">
          <span>© {new Date().getFullYear()} Elevare Solutions. Elevare — Latin, &ldquo;to elevate.&rdquo;</span>
        </div>

        <div
          data-testid="legal-disclaimer"
          className="mt-6 pt-6 border-t border-black/5 text-[10px] leading-relaxed text-black/40 max-w-4xl"
        >
          <p className="uppercase tracking-[0.22em] text-black/55 mb-2">Payment terms</p>
          <p>
            All payments made to Elevare Solutions — including retainers, engagement fees, monthly service fees,
            diagnostic bookings, digital deliverables, subscriptions, and any à-la-carte add-ons — are
            <strong className="text-black/60"> final, non-refundable, and non-transferable</strong> once
            processed, regardless of usage, cancellation, non-completion of any milestone, or subsequent
            change in circumstances. By submitting payment via our checkout, invoicing, ACH, card, or any
            other accepted method, the payer expressly acknowledges and agrees to this policy and waives any
            right to chargeback, reversal, or dispute except where required by applicable law. Elevare
            Solutions does not issue partial or pro-rated refunds. Estimated timelines, projected savings,
            AI-generated forecasts, and BBB-rating outcomes are illustrative and not guaranteed. All
            services are provided &ldquo;as is&rdquo; without warranty of any kind, and Elevare Solutions&rsquo;
            aggregate liability shall not exceed the fees actually paid for the specific service giving
            rise to the claim. This provision survives termination of any engagement. Contact
            kalib@elevaresolutions.me with any billing questions prior to submitting payment.
          </p>
          <p className="mt-3">
            <strong className="text-black/60">Recurring ACH Debit Authorization.</strong> When a client
            signs the Recurring ACH Debit Authorization inside their Customer Portal, they authorize
            Elevare Solutions LLC to initiate recurring electronic (ACH) debits from the bank account
            they have linked, on the schedule and in the amounts set forth in their service
            agreement. This authorization remains in full force and effect until the client revokes
            it in writing &mdash; either from their portal or by emailing kalib@elevaresolutions.me &mdash;
            and Elevare requires at least three (3) business days&rsquo; notice before the next
            scheduled debit to process a revocation. Returned items may be re-attempted up to two
            additional times as permitted by NACHA rules, and the client remains liable for the
            amount owed plus any bank fees.
          </p>
        </div>
      </div>
    </footer>
  );
}
